import './TeamMember.scss'
import DoubleBorder from "../../DoubleBorder/DoubleBorder"

const TeamMember = ({ name, role, description, imgUrl }) => {
  return (
    <div className="team-member">
      <DoubleBorder>
        <div className="team-member-photo">
          <img className="team-member-avatar" src={imgUrl} />
        </div>
        <div className="team-member-text">
          <div className="team-member-name">
            {name}
          </div>
          <div className="team-member-role">
            {role}
          </div>
          <div className="team-member-description">
            {description}
          </div>
        </div>
      </DoubleBorder >
    </div >
  )
}

export default TeamMember